import React from 'react';
import {
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@mui/material';
import type { SiteArea } from '../../services/sitesApi';

type Props = {
  areaId: string;
  placementLabel: string;
  areas: SiteArea[];
  disabled?: boolean;
  onAreaChange: (areaId: string) => void;
  onPlacementChange: (label: string) => void;
};

/** Area dropdown + edge placement fields for Devices edit dialog (Epic 281-A). */
export const DevicePlacementFields: React.FC<Props> = ({
  areaId,
  placementLabel,
  areas,
  disabled = false,
  onAreaChange,
  onPlacementChange,
}) => (
  <>
    <Grid item xs={12} md={6}>
      <FormControl fullWidth disabled={disabled}>
        <InputLabel>Area</InputLabel>
        <Select
          value={areaId}
          onChange={(e) => onAreaChange(String(e.target.value))}
          label="Area"
        >
          <MenuItem value="">—</MenuItem>
          {areas
            .filter((area) => area.active !== false)
            .map((area) => (
              <MenuItem key={area.area_id} value={area.area_id}>
                {area.display_name || area.area_id}
              </MenuItem>
            ))}
        </Select>
      </FormControl>
    </Grid>
    <Grid item xs={12} md={6}>
      <TextField
        fullWidth
        label="Edge placement"
        value={placementLabel}
        onChange={(e) => onPlacementChange(e.target.value)}
        placeholder="e.g., IT closet / rack (not site/area)"
        disabled={disabled}
      />
    </Grid>
  </>
);

export default DevicePlacementFields;
